import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FiAlertTriangle } from "react-icons/fi";
import { useUser } from "../../context/UserProvider";
import './Payment.css'
import Navbar from "../../components/navbars/Navbar";



const PaymentFailure = () => {
    const navigate = useNavigate();    
    const {mongoUser} = useUser();
    return (
        <div className="payment-container">
            <Navbar />
            <div className="payment-icon">
                <FiAlertTriangle size={80} color="brickred" />
            </div>
            <h1 className="payment-message failure">Payment Failed</h1>
            <p>There was an issue processing your payment. Please try again.</p>
            <button className="payment-button failure-button" onClick={() => navigate("/")}>
                Try Again
            </button>
        </div>
    );
};

export default PaymentFailure;

